import React, { FC, useState } from 'react'
import styled, { css } from 'styled-components'

import { ButtonStyled, Text } from '../CssStyled'
import { IconButton } from '@wirtualna-polska/n2cr-ds'
import { breakpoints } from '@ads/front-core/constants/breakpoints'
import { lng } from '@ads/front-core/locales'

interface IExamplesPreview {
  items: {
    name: string
    src: string
  }[]
  onClose: () => void
}

const ExamplesPreview: FC<IExamplesPreview> = ({ items, onClose }) => {
  const [currentSlide, setCurrentSlide] = useState(0)

  const handlePreviousClick = () => {
    setCurrentSlide(currentSlide === 0 ? items.length - 1 : currentSlide - 1)
  }

  const handleNextClick = () => {
    setCurrentSlide(currentSlide === items.length - 1 ? 0 : currentSlide + 1)
  }

  return (
    <Modal>
      <Container>
        <Card>
          <XCloseButtonWrapper>
            <XCloseButton name="20-close" onClick={onClose} />
          </XCloseButtonWrapper>

          <SliderImageContainer>
            <SliderButtonPrevious
              name="20-chevron-left"
              onClick={handlePreviousClick}
            />

            <SliderImage
              src={items[currentSlide].src}
              alt={`slide-${currentSlide + 1}`}
            />
            <SliderButtonNext
              name="20-chevron-right"
              onClick={handleNextClick}
            />
          </SliderImageContainer>
          <Footer>
            <Text>{items[currentSlide].name}</Text>

            <DotsWrapper>
              <IconButtonMobile
                name="20-chevron-left"
                onClick={handlePreviousClick}
              />
              <Dots>
                {items.map((img, index) => (
                  <Dot key={index} isActive={index === currentSlide} />
                ))}
              </Dots>
              <IconButtonMobile
                name="20-chevron-right"
                onClick={handleNextClick}
              />
            </DotsWrapper>
          </Footer>

          <ButtonClose onClick={onClose}>{lng('common:close')}</ButtonClose>
        </Card>
      </Container>
    </Modal>
  )
}

const Modal = styled.div`
  position: fixed;
  background-color: rgba(38, 38, 40, 0.3);
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 9999;
`
const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`

const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 1233px;
  height: 715px;
  margin: 72px auto;
  padding: 32px 82px 32px;
  border-radius: 55px;
  background-color: white;

  @media (max-width: ${breakpoints.MOBILE}) {
    position: fixed;
    inset: 0px 0px 0px;
    width: 100vw;
    height: 100%;
    overflow: none;
    border-radius: 0px;
    padding: 32px 16px;
    margin: 0px;
  }
`

const SliderImageContainer = styled.div`
  position: relative;
  height: 100%;
  border: 1px solid #e6e8ed;
  border-radius: 8px;

  @media (max-width: ${breakpoints.MOBILE}) {
    flex: none;
    height: 156px;
    margin-top: 124px;
  }
`

const SliderImage = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  object-fit: contain;
`

const SliderButton = css`
  position: absolute;
  width: 100px;
  height: 100px;
  border: none;
  border-radius: 50%;
  outline: none;
  color: black;
  background-color: white;
  top: 50%;
  transform: translateY(-50%);
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.15);
  z-index: 99;
  cursor: pointer;

  &:active {
    opacity: 1;
  }

  svg {
    width: 47px;
    height: 47px;
  }

  @media (max-width: ${breakpoints.MOBILE}) {
    display: none;
  }
`

const SliderButtonPrevious = styled(IconButton)`
  ${SliderButton}
  left: -50px;
`

const SliderButtonNext = styled(IconButton)`
  ${SliderButton}
  right: -50px;
`

const IconButtonMobile = styled(IconButton)`
  display: none;
  width: 30px;
  height: 30px;

  @media (max-width: ${breakpoints.MOBILE}) {
    display: block;
  }
`

const Footer = styled.div`
  display: flex;

  justify-content: space-between;

  @media (max-width: ${breakpoints.MOBILE}) {
    flex-direction: column;
    height: 100%;
  }
`

const DotsWrapper = styled.div`
  @media (max-width: ${breakpoints.MOBILE}) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
`

const Dots = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 24px;
`

const Dot = styled.span<{ isActive }>`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: ${p => (p.isActive ? '#EC1C24' : '#E6E8ED')};
`

const ButtonClose = styled.a`
  ${ButtonStyled}
  color: #71757d;
  border: 2px solid #e6e8ed;
  background-color: #fff;
  width: 100%;
  width: fit-content;
  align-self: center;

  &:hover {
    color: #71757d;
    background-color: #fff;
  }
`

const XCloseButtonWrapper = styled.div`
  text-align: end;
  height: 21px;
`

const XCloseButton = styled(IconButton)`
  margin-right: -48px;
  color: #e5e5e5;

  @media (max-width: ${breakpoints.MOBILE}) {
    margin: 0;
  }
`

export default ExamplesPreview
